// fxdoctor.pro community membership (owner decision 2026-09-07): /live is members-only.
// Server-side truth is the SQL function is_community_member(); this file holds the shared
// types + admin rule. Kinds mirror the CommunityMember.kind check constraint.
//
// "Community" = fxdoctor.pro's real "Zajednica" product (verified 2026-09-07 on fxdoctor.pro/zajednica):
// a paid coaching membership — twice-monthly setup-review sessions, weekly analysis, Thursday Q&A,
// full archive. NOT signals. 100 €/month (or 1.000 €/year), discounted by PU Prime account balance
// under the FX Doctor IB link: 500 €+ → 75 €, 1.000 €+ → 50 €, 2.500 €+ → 0 € (still requires joining —
// the balance only zeroes the fee, a PU Prime account by itself isn't automatic access). Mentorski kurs
// (600 €) and Master 1-na-1 (3.300 €) graduates get everything Zajednica has, per fxdoctor.pro/zajednica's
// own tier comparison. DayProp is an unrelated funded-account product (a Mentorski kurs bonus, not a
// path into the community) — dropped from the kind list 2026-09-07.
//
// Separately, "FX Doctor's Gold" (this Channel id below) is a DIFFERENT, ShowMeTrade-native product —
// paid XAUUSD signals, $100/mo or free with a $2.000+ PU Prime deposit + DM confirmation. Subscribing
// through the in-app channel checkout (/channels/{id}) grants /live automatically via
// is_community_member() — that flow carries the metadata our Stripe webhook needs. The external Stripe
// Payment Link below (owner, 2026-09-08 — for marketing outside the app: Telegram/IG/WhatsApp) does
// NOT carry that metadata, so it can't auto-grant; those payers go through the same manual
// request-and-approve path as Zajednica (kind GOLD, hint asks for the Stripe receipt email).
export const FXDOCTOR_GOLD_CHANNEL_ID = '7a9bf42d-e4bf-4c1e-9eb5-1feb6fb05ae9';
export const FXDOCTOR_GOLD_STRIPE_LINK = 'https://buy.stripe.com/28E4gz1hD0p68SfbZIdQQ0x';
export const FXDOCTOR_USER_ID = '1f655745-2cb8-4279-a226-8079fba7404f';

export type CommunityKind = 'ZAJEDNICA' | 'GOLD' | 'PUPRIME' | 'MENTOR' | 'ONE_ON_ONE' | 'OTHER';
export type CommunityStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

// Owner correction 2026-09-07: Zajednica is registered and PAID entirely on fxdoctor.pro
// (Stripe join link on that page) — showmetrade.com only grants /live access afterwards, it
// never collects payment or PU-Prime-balance discount details itself. So a plain "ZAJEDNICA"
// kind (matched by the email/name the member signed up with) comes first — PUPRIME is now
// only for someone citing their PU Prime account as the reason their Zajednica fee is
// discounted/free, not a separate standalone path.
export const COMMUNITY_KINDS: { value: CommunityKind; label: string; hint: string }[] = [
  { value: 'ZAJEDNICA', label: 'Zajednica member (paid on fxdoctor.pro)', hint: 'Email or name you registered with on fxdoctor.pro' },
  { value: 'GOLD', label: "Paid FX Doctor's Gold via the Stripe link", hint: 'Email you used at Stripe checkout' },
  { value: 'PUPRIME', label: 'PU Prime account under the FX Doctor link', hint: 'Account number and balance (2 500 €+ = free Zajednica)' },
  { value: 'MENTOR', label: 'Completed the Mentorski kurs', hint: 'Year / month, or your name as registered' },
  { value: 'ONE_ON_ONE', label: 'Completed Master 1-na-1', hint: 'Year / month, or your name as registered' },
  { value: 'OTHER', label: 'Something else', hint: 'Tell us how you are part of the community' },
];

export interface CommunityRequest {
  userId: string; kind: CommunityKind; reference: string | null; note: string | null; status: CommunityStatus;
  adminNote: string | null; createdAt: string; decidedAt: string | null;
}
